export default () => jQuery(($) => {

	$('.form-element[data-display-conditions]')
		.each(function () {
			var target = $(this);
			var data = target.data('display-conditions');
			var num_conditions = data.conditions.length;
			var get_value = function (element) {
				if (element.hasClass('form-element--radio')) {
					return element.find('input:checked')
						.val();
				}
				if (element.hasClass('form-element--checkbox')) {
					var values = [];
					var checked = element.find('input:checked');
					checked.each(function () {
						values[i] = $(this)
							.val();
					});
					// console.log(values);
					return values;
				}
				return element.val();
			};
			var attach_change_event = function (element, event) {
				if (element.hasClass('form-element--radio')) {
					element.find('input')
						.change(function () {
							event();
						});
				}
				element.change(function () {
					event();
				});
			};
			var update_display = function () {
				// console.log('update_display');
				var num_matches = 0;
				for (var i = 0; i < num_conditions; i++) {
					// console.log(data.conditions[i].id);
					// console.log(data.conditions[i].value);
					var element = $('#' + data.conditions[i].id);
					var value = get_value(element);
					if (Array.isArray(value)) {
						for (var j = 0; j < value.length; j++) {
							if (value[j] == data.conditions[i].value) {
								// console.log('array match');
								num_matches++;
							}
						}
					} else if (value == data.conditions[i].value) {
						// console.log('simple match');
						num_matches++;
					}
				}
				// console.log("num_matches: " + num_matches);
				var hit;
				if (data.combination == 'any') {
					hit = (num_matches > 0);
				} else {
					hit = (num_matches == num_conditions);
				}
				if (data.result == 'hide') {
					if (hit) {
						// console.log("hide hit");
						target.hide();
						target.prop('disabled', true);
					} else {
						// console.log("hide miss");
						target.show();
						target.prop('disabled', false);
					}
				} else {
					if (hit) {
						// console.log("show hit");
						target.show();
						target.prop('disabled', false);
					} else {
						// console.log("show miss");
						target.hide();
						target.prop('disabled', true);
					}
				}
			};
			for (var i = 0; i < num_conditions; i++) {
				var element = $('#' + data.conditions[i].id);
				if (element.length) {
					attach_change_event(element, update_display);
				}
			}
			update_display();
		});
});
